export const dummyStructure = {
  data: {
    code: "0200",
    count: 12,
    brand: "EM",
    data: [
      {
        action: "link",
        label: "상품검색",
        value: "/search",
        category: "상품",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_search.svg",
        order: 1,
        badge: null,
      },
      {
        action: "webLink",
        label: "점포시설/휴점일",
        value: "https://emartapp.emart.com/branch/view.do?id=1086&mallGbn=E",
        category: "행사 및 점포정보",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_store.svg",
        order: 2,
        badge: null,
      },
      {
        action: "webLink",
        label: "빠른환불",
        value: "https://qrefund.emart.com/main",
        category: "상품",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_refund.svg",
        order: 3,
        badge: null,
      },
      {
        action: "link",
        label: "e-유실물센터",
        value: "/lost",
        category: "기타",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_loss.svg",
        order: 4,
        badge: {
          color: "#813DB5",
          text: "NEW",
        },
      },

      {
        action: "link",
        label: "전단광고",
        value: "https://emartapp.emart.com/branch/view.do?id=1002&mallGbn=E",
        category: "행사 및 점포정보",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_ad.svg",
        order: 5,
        badge: null,
      },
      {
        action: "link",
        label: "공지사항",
        value: "/notice",
        category: "기타",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_notice.svg",
        order: 6,
        badge: null,
      },
      {
        action: "webLink",
        label: "디지털맵",
        value: "https://e-compass-client.emart.com/find/store/1086/map",
        category: "행사 및 점포정보",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_map.svg",
        order: 7,
        badge: null,
      },
      {
        action: "link",
        label: "A/S업체안내",
        value: "/after-service",
        category: "기타",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_as.svg",
        order: 8,
        badge: null,
      },
      {
        action: "link",
        label: "유니버스클럽",
        value: "/universe-club",
        category: "기타",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_club.svg",
        order: 9,
        badge: null,
      },
      {
        action: "link",
        label: "상품권",
        value: "/gift-card",
        category: "기타",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_voucher.svg",
        order: 10,
        badge: null,
      },

      {
        action: "webLink",
        label: "이마티콘",
        value: "https://emarticonweb.emarticon.mycloudmembership.com/home",
        category: "기타",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_ematicon.svg",
        order: 11,
        badge: null,
      },

      {
        action: "webLink",
        label: "문화센터",
        value: "https://m.cultureclub.emart.com",
        category: "기타",
        icon: "http://charge.intermediary.co.kr/images/icon_nav_culture.svg",
        order: 12,
        badge: null,
      },
    ],
  },
};

export const nbQuickMenu = {
  data: [
    {
      action: "link",
      label: "상품검색",
      value: "/search",
      category: "상품",
      icon: "https://erody-img.emart.com/quickmenu/icon_nav_search.svg",
      order: 1,
      badge: null,
      requiresStore: true,
    },
    // {
    //   action: "webLink",
    //   label: "점포시설/휴점일",
    //   value: "https://emartapp.emart.com/branch/view.do?id=3160&mallGbn=E",
    //   category: "행사 및 점포정보",
    //   icon: "https://erody-img.emart.com/quickmenu/icon_nav_store.svg",
    //   order: 2,
    //   badge: null,
    //   requiresStore: true,
    // },
    {
      action: "link",
      label: "전단광고",
      value: "/flyers",
      category: "행사 및 점포정보",
      icon: "https://erody-img.emart.com/quickmenu/icon_nav_voucher2.svg",
      order: 6,
      badge: null,
      requiresStore: false,
    },
    {
      action: "webLink",
      label: "교환/환불",
      value: "/refund",
      category: "상품",
      icon: "https://erody-img.emart.com/quickmenu/icon_nav_return.svg",
      order: 3,
      badge: null,
      requiresStore: false,
    },
    // {
    //   action: "webLink",
    //   label: "온라인 문의",
    //   value: "https://eapp.emart.com/customer/customerMain.do",
    //   category: "기타",
    //   icon: "https://erody-img.emart.com/quickmenu/icon_nav_online.svg",
    //   order: 4,
    //   badge: null,
    //   requiresStore: false,
    // },

    // {
    //   action: "link",
    //   label: "상품권",
    //   value: "/gift-card",
    //   category: "기타",
    //   icon: "https://erody-img.emart.com/quickmenu/icon_nav_voucher.svg",
    //   order: 5,
    //   badge: null,
    //   requiresStore: false,
    // },
  ],
};


export const edQuickMenu = {
  data: [
    {
      action: "link",
      label: "자주하는 질문",
      value: "https://emile.emarteveryday.co.kr/customer/FAQ?chatbot=Y",
      category: "기타",
      icon: "https://erody-img.emart.com/quickmenu/icon_nav_faq.svg",
      order: 1,
      badge: null,
      requiresStore: false,
    },
    {
      action: "webLink",
      label: "교환/환불",
      value: "/refund",
      category: "상품",
      icon: "https://erody-img.emart.com/quickmenu/icon_nav_return.svg",
      order: 2,
      badge: null,
      requiresStore: false,
    },
    {
      action: "link",
      label: "전단광고",
      value: "https://emile.emarteveryday.co.kr/exhibition/leafletExhibitionView?uid=bKjFpmF2vyaVSccZdlrK",
      category: "행사 안내",
      icon: "https://erody-img.emart.com/quickmenu/icon_nav_ad.svg",
      order: 3,
      badge: null,
      requiresStore: false,
    },
  ],
};
